
(function waitForJqueryAndRun() {
  if (typeof window.jQuery === 'undefined') { setTimeout(waitForJqueryAndRun, 100); return; }

  $(function () {
    /* =========================
       ZÁKLADNÍ KONFIG A HELPERY
       ========================= */
    const allowedBrands = ['Dřevočal','MPO Matrace','Materasso','Magniflex','Moravia Comfort','Řešeto'];
    const STORAGE_PREFIX = 'custom-mattress:';
    const ATYP_STORE_ID  = 'atyp-store';

    const clean = s => String(s||'').replace(/\s+/g,' ').trim();
    const nowTs = () => Date.now();
    const slug  = (s) => String(s||'')
      .normalize('NFKD').replace(/[\u0300-\u036f]/g,'')
      .toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/-+/g,'-')
      .replace(/^-|-$/g,'');
    const makeKey = (productName, w, h) => `${STORAGE_PREFIX}${slug(productName)}--${w}x${h}`;

    // volnější porovnání názvů (odstranění rozměrů, "cm", atd.)
    const looseMatch = (a, b) => {
      const A = slug(a), B = slug(b); if (!A || !B) return false;
      if (A === B) return true;
      const stripDims = t => t
        .replace(/-\d+(?:-\d+)?-?cm\b/g,'')
        .replace(/-\d+-?cm\b/g,'')
        .replace(/-\d{2,3}\b/g,'');
      const As = stripDims(A), Bs = stripDims(B);
      return As === Bs || As.includes(Bs) || Bs.includes(As) || A.includes(B) || B.includes(A);
    };

    function parseSizeAnywhere(txt) {
      const m = String(txt||'').match(/(\d{2,3})\s*[x×]\s*(\d{2,3})\s*(?:cm)?/i);
      return m ? { w: parseInt(m[1],10), h: parseInt(m[2],10) } : null;
    }

    /* =========================================
       DOM STORE #atyp-store (zrcadlo více atypů)
       ========================================= */
    function ensureDomStore(){
      let $el = $(`#${ATYP_STORE_ID}`);
      if(!$el.length){
        $el = $(`<div id="${ATYP_STORE_ID}" style="display:none" aria-hidden="true"></div>`);
        $('body').append($el);
      }
      return $el;
    }
    function destroyDomStore(){ $(`#${ATYP_STORE_ID}`).remove(); }
    window.addEventListener('pagehide', destroyDomStore);
    window.addEventListener('beforeunload', destroyDomStore);

    function domUpsertAtypEntry(entry) {
      const $root = ensureDomStore();
      const key = makeKey(entry.cleanProductName, entry.width, entry.height);
      const $old = $root.find(`.atyp-item[data-key="${key}"]`);
      const $node = $(`
        <div class="atyp-item"
          data-key="${key}"
          data-product="${entry.cleanProductName||''}"
          data-product-slug="${entry.productSlug||''}"
          data-width="${entry.width}"
          data-height="${entry.height}"
          data-sku="${entry.sku||''}"
          data-source="${entry.source||''}"
          data-savedat="${entry.savedAt||nowTs()}"></div>
      `);
      if ($old.length) $old.replaceWith($node); else $root.append($node);
    }
    function readDomStore() {
      const $root = $(`#${ATYP_STORE_ID}`); if(!$root.length) return [];
      const out = [];
      $root.find('.atyp-item').each(function(){
        const $i = $(this);
        const width  = parseInt($i.attr('data-width'),10);
        const height = parseInt($i.attr('data-height'),10);
        if (!width || !height) return;
        out.push({
          cleanProductName: $i.attr('data-product')||'',
          productSlug: $i.attr('data-product-slug')||'',
          width, height,
          sku: $i.attr('data-sku')||'',
          source: $i.attr('data-source')||'',
          savedAt: parseInt($i.attr('data-savedat'),10)||0
        });
      });
      out.sort((a,b)=>(b.savedAt||0)-(a.savedAt||0)); // nejnovější první
      return out;
    }
    function loadAllAtypEntries() {
      const out = [];
      try {
        for (let i=0;i<sessionStorage.length;i++){
          const k=sessionStorage.key(i);
          if(!k||!k.startsWith(STORAGE_PREFIX)) continue;
          try {
            const obj = JSON.parse(sessionStorage.getItem(k));
            if(obj && obj.width && obj.height) out.push(obj);
          } catch {}
        }
      } catch(e){ console.warn('[ATYP] Chyba při čtení sessionStorage', e); }
      out.sort((a,b)=>(b.savedAt||0)-(a.savedAt||0));
      return out;
    }
    function syncDomStoreFromSession() {
      const list = loadAllAtypEntries();
      const $root = ensureDomStore().empty();
      list.forEach(domUpsertAtypEntry);
      return list;
    }
    function saveAtypEntry(entry){
      if(!entry||!entry.cleanProductName||!entry.width||!entry.height) return;
      const toSave = { ...entry, savedAt: entry.savedAt||nowTs(), productSlug: slug(entry.cleanProductName) };
      try { sessionStorage.setItem(makeKey(entry.cleanProductName, entry.width, entry.height), JSON.stringify(toSave)); } catch(e){ console.warn('[ATYP] sessionStorage fail', e); }
      domUpsertAtypEntry(toSave);
    }

    /* =========================
       VÝBĚR VARIANT – pomocné
       ========================= */
    const isAllowedBrand = () => {
      let ok=false;
      $('.type-detail .product-top a[data-testid="productCardBrandName"] span').each(function(){
        const t = $(this).text().trim(); if (allowedBrands.includes(t)) { ok=true; return false; }
      });
      return ok;
    };
    const isMattressTitle = () => $('.p-detail-inner-header h1').text().toLowerCase().includes('matrace');
    const getCleanProductNameFromH1 = () => clean($('.p-detail-inner-header h1').text());

    function getRozmerLabels(){ return $('.choose-parameters-wrap.rozmer .labels-container label'); }
    function getMaxWidthFromLabels(){
      let maxW=0; getRozmerLabels().each(function(){ const sz=parseSizeAnywhere($(this).text()); if(sz&&sz.w>maxW) maxW=sz.w; }); return maxW;
    }
    function selectCeilOrNearest(inputW,inputH){
      const $labels=getRozmerLabels(); if(!$labels.length) return false;
      const vars=[];
      $labels.each(function(){
        const t=$(this).text(); const m=parseSizeAnywhere(t); if(!m) return;
        vars.push({ $radio:$(this).find('input[type=radio]'), w:m.w, h:m.h, area:m.w*m.h });
      });
      if(!vars.length) return false;
      const exact=vars.find(v=>v.w===inputW&&v.h===inputH); if(exact){ exact.$radio.trigger('click'); return true; }
      const ge=vars.filter(v=>v.w>=inputW&&v.h>=inputH);
      if(ge.length){
        ge.sort((a,b)=>{
          const da=(a.w-inputW)+(a.h-inputH), db=(b.w-inputW)+(b.h-inputH);
          if(da!==db) return da-db; const dWa=a.w-inputW, dWb=b.w-inputW;
          if(dWa!==dWb) return dWa-dWb; return a.area-b.area;
        });
        ge[0].$radio.trigger('click'); return true;
      }
      let best=null, min=Infinity;
      for(const v of vars){
        const diff=Math.abs(v.w-inputW)+Math.abs(v.h-inputH);
        if( diff<min || (diff===min && Math.abs(v.w-inputW)<Math.abs(best?.w-inputW)) || (diff===min && Math.abs(v.w-inputW)===Math.abs(best?.w-inputW) && v.area<(best?.area??Infinity)) ){
          min=diff; best=v;
        }
      }
      if(best){ best.$radio.trigger('click'); return true; }
      return false;
    }

    /* =========================
       DETAIL PRODUKTU (admin + matrace) + PEVNÉ OTEVÍRÁNÍ PICKERU
       ========================= */
    if ($('body').hasClass('admin-logged') && isAllowedBrand() && isMattressTitle()) {
      // 1) robustní CSS – otevřený picker se NIKDY neschová sám
      if (!$('#custom-size-picker-style').length) {
        $('head').append(
          '<style id="custom-size-picker-style">'+
          '#custom-size-picker[data-state="open"]{display:grid!important;opacity:1!important;visibility:visible!important;height:auto!important}'+
          '#custom-size-picker[data-state="closed"]{display:none!important}'+
          '.type-detail .master-radio-wrapper{overflow:visible!important}'+
          '</style>'
        );
      }

      // 2) UI prvky
      $(
        '<button id="toggle-size-picker" type="button" class="btn">Rozměr na přání</button>'+
        '<div id="custom-size-picker" data-state="closed">'+
        '<label><span>šířka</span><input type="number" id="input-width" min="0"><span>cm</span></label>'+
        '<label><span>výška</span><input type="number" id="input-height" min="0"><span>cm</span></label>'+
        '</div>'
      ).insertAfter('.type-detail .master-radio-wrapper .choose-parameters-wrap.rozmer');

      ensureDomStore();

      // 3) otevřenost pickeru – počáteční stav ZAVŘENO (jak chcete)
      let pickerWantedOpen=false;

      function syncPickerVisualWithState() {
        const $picker = $('#custom-size-picker');
        if (!$picker.length) return;
        $picker.attr('data-state', pickerWantedOpen ? 'open' : 'closed'); // jen data-state, wrapper netogglujeme
      }
      function openPicker(){ pickerWantedOpen=true;  syncPickerVisualWithState(); }
      function closePicker(){ pickerWantedOpen=false; syncPickerVisualWithState(); }

      // Toggle tlačítkem
      $(document).off('click','#toggle-size-picker').on('click','#toggle-size-picker',function(e){
        e.preventDefault();
        pickerWantedOpen = !pickerWantedOpen;
        syncPickerVisualWithState();
        if (pickerWantedOpen) { const w=document.getElementById('input-width'); if (w) setTimeout(()=>w.focus(),0); }
        return false;
      });

      // 4) Watchdog: když Shoptet přerenderuje, znovu picker případně přimontuj a OTEVŘI pokud byl otevřen
      function mountPickerIfMissing() {
        if (!$('#custom-size-picker').length) {
          $(
            '<div id="custom-size-picker" data-state="closed">'+
            '<label><span>šířka</span><input type="number" id="input-width" min="0"><span>cm</span></label>'+
            '<label><span>výška</span><input type="number" id="input-height" min="0"><span>cm</span></label>'+
            '</div>'
          ).insertAfter('.type-detail .master-radio-wrapper .choose-parameters-wrap.rozmer');
        }
      }
      function forcePickerOpenIfWanted() {
        mountPickerIfMissing();
        if (pickerWantedOpen) $('#custom-size-picker').attr('data-state','open');
      }
      $(document).on('ShoptetVariantChanged ShoptetDOMUpdated', function(){
        setTimeout(forcePickerOpenIfWanted, 0);
        setTimeout(forcePickerOpenIfWanted, 120);
        setTimeout(forcePickerOpenIfWanted, 360);
      });
      if ('MutationObserver' in window) {
        const mo = new MutationObserver(() => setTimeout(forcePickerOpenIfWanted,0));
        mo.observe(document.body, { childList:true, subtree:true });
      }

      // 5) Klik na label varianty zavírá JEN při skutečném uživatelském kliku (syntetické ignoruj)
      $(document)
        .off('click', '.choose-parameters-wrap.rozmer .labels-container label')
        .on('click', '.choose-parameters-wrap.rozmer .labels-container label', function (e) {
          // jQuery syntetika?
          if (e.isTrigger) return;
          // nativní, ale ne-uživatelský (programový) event?
          if (!(e.originalEvent && e.originalEvent.isTrusted)) return;
          // OK, člověk opravdu kliknul → zavřít
          closePicker();
        });

      // 6) Varianta – select/label volba + uložení ATYP
      const variantOptions=[];
      $('#parameter-id-6 option').each(function(){
        const t=$(this).text().trim(); const m=parseSizeAnywhere(t);
        if(m){ variantOptions.push({ width:m.w, height:m.h, value:$(this).val(), index:$(this).attr('data-index'), text:t }); }
      });

      let tmr;
      function onInput(){
        clearTimeout(tmr);
        tmr=setTimeout(()=>{
          $('#potah-alert, #atyp-alert').remove();

          // NIKDY automaticky nezavírat při psaní – jen udrž vizuální stav
          syncPickerVisualWithState();

          const W=parseInt($('#input-width').val(),10);
          const H=parseInt($('#input-height').val(),10);
          if(Number.isNaN(W)||Number.isNaN(H)) return;

          const cleanName=getCleanProductNameFromH1(); if(!cleanName) return;

          // okamžité uložení + zápis do DOM store
          const skuNow=$('.type-detail .p-info-wrapper .p-code .parameter-dependent:visible').text().trim();
          saveAtypEntry({ width:W, height:H, cleanProductName:cleanName, sku:skuNow||'', source:'typed' });

          const maxW=getMaxWidthFromLabels();
          if(maxW && W>maxW){
            $('<div id="atyp-alert" style="padding:1em;background:#d1ecf1;border:1px solid #bee5eb;margin-bottom:1em;font-weight:700">Zadali jste šířku větší, než je v běžné nabídce – vyrobíme vám rozměr na míru. <a href="/kontakty" style="text-decoration:underline">Kontaktujte nás</a>.</div>')
              .insertAfter('.choose-parameters-wrap.rozmer');
          }

          // Programové kliky na labely kvůli doměření varianty – už NEzavřou picker (viz handler výše)
          const clicked=selectCeilOrNearest(W,H);
          if(!clicked){
            const exact=variantOptions.find(o=>o.width===W&&o.height===H);
            if(exact){
              const $sel=$('#parameter-id-6'); if($sel.length){ $sel.val(exact.value).trigger('input').trigger('change'); $(document).trigger('ShoptetVariantChanged'); }
            } else {
              let best=null,min=Infinity;
              for(const o of variantOptions){ const d=Math.abs(o.width-W)+Math.abs(o.height-H); if(d<min){ min=d; best=o; } }
              if(best){ const $sel=$('#parameter-id-6'); if($sel.length){ $sel.val(best.value).trigger('input').trigger('change'); $(document).trigger('ShoptetVariantChanged'); } }
            }
          }

          // zkus později doplnit SKU (po doměření varianty)
          const target=document.querySelector('.type-detail .p-info-wrapper .p-code .parameter-dependent');
          let saved=false;
          const fb=setTimeout(()=>{
            if(saved) return;
            const t=$('.type-detail .p-info-wrapper .p-code .parameter-dependent:visible').text().trim();
            saveAtypEntry({ width:W, height:H, cleanProductName:cleanName, sku:t||'', source:'typed+fallback' });
          }, 600);
          if(target && 'MutationObserver' in window){
            const mo=new MutationObserver(()=>{
              const t=$('.type-detail .p-info-wrapper .p-code .parameter-dependent:visible').text().trim();
              if(!saved && t){ saved=true; clearTimeout(fb); mo.disconnect(); saveAtypEntry({ width:W, height:H, cleanProductName:cleanName, sku:t, source:'typed+mo' }); }
            });
            mo.observe(target,{ childList:true, characterData:true, subtree:true });
          }
        }, 250);
      }
      $('#input-width, #input-height').on('input', onInput);
      setTimeout(onInput, 200);
    }

    /* =========================
       POZNÁMKY (id--17)
       ========================= */
    if ($('body').hasClass('id--17')) {
      const storedArr = syncDomStoreFromSession();
      if (storedArr.length) {
        setTimeout(()=>{
          const $toggle=$('#add-note'); const $wrap=$('#note');
          if($toggle.length && !$toggle.prop('checked')) $toggle.prop('checked',true).trigger('change');
          $wrap.removeClass('js-hidden').addClass('visible');
          $('#remark').val(storedArr.map(x=>`Atypický rozměr ${x.cleanProductName}: ${x.width}x${x.height} cm`).join('\n'));
        },300);
      }
    }

    /* =========================
       HELPER: počkej na vykreslení DOMu
       ========================= */
    function waitFor(selector, {tries=60, interval=150} = {}) {
      return new Promise(resolve=>{
        let left=tries;
        const tick=()=>{ if($(selector).length) return resolve(true); if(--left<=0) return resolve(false); setTimeout(tick, interval); };
        tick();
      });
    }

    /* =========================
       PÁROVÁNÍ KOŠÍK/REKAP (s „poslední“ fallback)
       ========================= */
    function findAtypForCartItem($row, storedArrDomFirst){
      const productName = clean(
        $row.find('a.main-link, [data-micro="cartItemName"] a, .cart-item-name a, .p-name a, .product-name a, .name a').first().text() ||
        $row.find('[data-micro="cartItemName"], .cart-item-name, .p-name, .product-name, .name').first().text()
      );
      const productSlugCandidate = slug(productName);

      const variantStr = clean(
        $row.find('[data-micro="cartItemVariant"], .main-link-variant, .p-variant, .variant, .cart-item-variants, .cart-variants, .variant-name, .param-value, .param-row, .cart-params, .product-variants').first().text()
      ) || clean($row.text());
      const dim = parseSizeAnywhere(variantStr);

      let itemSku = clean(
        $row.attr('data-micro-sku') ||
        $row.find('[data-micro-sku]').attr('data-micro-sku') ||
        $row.find('.p-code, .product-code, .code, .sku').first().text()
      );
      if (itemSku) itemSku = itemSku.trim();

      // 0) přesný produkt SLUG + rozměr
      if (productSlugCandidate && dim){
        const hit = storedArrDomFirst.find(x => x.productSlug === productSlugCandidate && x.width===dim.w && x.height===dim.h);
        if (hit) return hit;
      }

      // 1) z #atyp-store: uvolněná shoda názvu (+ volitelně rozměr)
      if (productName){
        const hit = storedArrDomFirst.find(x =>
          looseMatch(x.cleanProductName, productName) &&
          (!dim || ((x.width===dim.w && x.height===dim.h) || (x.width===dim.h && x.height===dim.w)))
        );
        if (hit) return hit;
      }

      // 2) sessionStorage: přímý klíč název+rozměr
      if (productName && dim){
        try {
          const raw = sessionStorage.getItem(makeKey(productName, dim.w, dim.h));
          if (raw){ const obj=JSON.parse(raw); if(obj && obj.width===dim.w && obj.height===dim.h) return obj; }
        } catch {}
      }

      // 3) uvolněná shoda názvu + rozměr
      if (productName && dim){
        const byLoose = storedArrDomFirst.find(x =>
          looseMatch(x.cleanProductName, productName) &&
          ((x.width===dim.w && x.height===dim.h) || (x.width===dim.h && x.height===dim.w))
        );
        if (byLoose) return byLoose;
      }

      // 4) SKU fallback
      if (itemSku){
        if (dim){
          const bySkuDim = storedArrDomFirst.find(x => x.sku && x.sku.trim()===itemSku && ((x.width===dim.w && x.height===dim.h) || (x.width===dim.h && x.height===dim.w)));
          if (bySkuDim) return bySkuDim;
        }
        const skuMatches = storedArrDomFirst.filter(x => x.sku && x.sku.trim()===itemSku);
        if (skuMatches.length===1) return skuMatches[0];
        if (productName){
          const bySkuName = storedArrDomFirst.find(x => x.sku && x.sku.trim()===itemSku && looseMatch(x.cleanProductName, productName));
          if (bySkuName) return bySkuName;
        }
      }

      // 5) když v řádku NENÍ rozměr a pro produkt máme JEDINÝ rozměr → použij ho
      if (productName){
        const sameProd = storedArrDomFirst.filter(x => looseMatch(x.cleanProductName, productName) || x.productSlug===productSlugCandidate);
        const distinct = Array.from(new Set(sameProd.map(x => `${x.width}x${x.height}`)));
        if (!dim && distinct.length===1) return sameProd[0];

        // 6) POSLEDNÍ FALLBACK: vezmi NEJNOVĚJŠÍ uložený atyp pro daný produkt
        if (sameProd.length) return sameProd[0];
      }

      return null;
    }

    /* =========================
       REKAPITULACE (id--16)
       ========================= */
    if ($('body').hasClass('id--16')) {
      (async () => {
        if (!$('#custom-note-style').length) $('head').append('<style id="custom-note-style">.custom-note{display:block;margin-top:6px;font-size:13px;opacity:.85}</style>');

        const storedArr = syncDomStoreFromSession();
        await waitFor('[data-micro="cartItem"], .cart-items .cart-item, .summary-table tr, .order-summary .item, .recap-items .item');

        setTimeout(()=>{
          const $rows = $('[data-micro="cartItem"], .cart-items .cart-item, .summary-table tr, .order-summary .item, .recap-items .item');
          $rows.each(function(i){
            const $row = $(this);
            const entry = findAtypForCartItem($row, storedArr);
            const $name = $row.find('[data-micro="cartItemName"], .cart-item-name, .p-name, .product-name, .name').first();
            const $mount = $name.length ? $name : $row;

            $mount.find('.custom-note').remove();
            if (!entry) return;

            const msg = `Atypický rozměr ${entry.width}x${entry.height} cm`;
            const $after = $mount.find('a.main-link, a').first();
            const $note = $('<span class="custom-note atyp-note"></span>').text(msg);
            if ($after.length) $note.insertAfter($after); else $mount.append($note);
          });
        }, 80);
      })();
    }

    /* =========================
       KOŠÍK (id--9)
       ========================= */
    if ($('body').hasClass('id--9')) {
      (async () => {
        if (!$('#custom-note-style').length) $('head').append('<style id="custom-note-style">.custom-note{display:block;margin-top:6px;font-size:13px;opacity:.85}</style>');

        function renderCartNotes(){
          syncDomStoreFromSession();                 // vždy aktualizuj DOM store
          const storedArrDom = readDomStore();       // čti primárně z #atyp-store
          const msgOf = e => `Atypický rozměr ${e.width}x${e.height} cm`;

          // tabulkové řádky
          $('.cart-table tr.removeable, .cart-table tr[data-micro="cartItem"]').each(function(i){
            const $tr=$(this);
            const entry = findAtypForCartItem($tr, storedArrDom);
            const $nameCell = $tr.find('[data-micro="cartItemName"], .p-name, .cart-item-name, .product-name, .name').first();
            const $mount = $nameCell.length ? $nameCell : $tr;
            $mount.find('.custom-note').remove();
            if(!entry) return;
            const $link = $mount.find('a, .main-link').first();
            const $note = $('<div class="custom-note atyp-note"></div>').text(msgOf(entry));
            if($link.length) $note.insertAfter($link); else $mount.append($note);
          });

          // kartičky
          $('.cart-items .cart-item, [data-micro="cartItem"]').each(function(i){
            const $item=$(this);
            const entry = findAtypForCartItem($item, storedArrDom);
            const $name = $item.find('[data-micro="cartItemName"], .cart-item-name, .product-name, .name, .p-name').first();
            const $mount = $name.length ? $name : $item;
            $mount.find('.custom-note').remove();
            if(!entry) return;
            const $link = $mount.find('a.main-link, a').first();
            const $note = $('<span class="custom-note atyp-note"></span>').text(msgOf(entry));
            if($link.length) $note.insertAfter($link); else $mount.append($note);
          });
        }

        const ok = await waitFor('.cart-table tr.removeable, .cart-items .cart-item, [data-micro="cartItem"]');
        if (ok) setTimeout(renderCartNotes, 100);

        $(document).on('ShoptetCartUpdated ShoptetCartContentLoaded ShoptetDOMUpdated', () => {
          setTimeout(renderCartNotes, 80);
        });

        const target = document.querySelector('#content') || document.body;
        if (target && 'MutationObserver' in window) {
          const mo=new MutationObserver(()=>setTimeout(renderCartNotes,50));
          mo.observe(target,{ childList:true, subtree:true });
        }
      })();
    }
  });
})();
